<!-- 收货 -->
<template>
  <div class="page-content">
    <c-header pageName="订单撤单"></c-header>
    <div class="nav-tool">
      <section :class="status===0?'activity':''" @click="statusChange(0)">待处理</section>
      <section :class="status===1?'activity':''" @click="statusChange(1)">处理中</section>
      <section :class="status===2?'activity':''" @click="statusChange(2)">已处理</section>
    </div>
    <div class="order-total">
      共 {{ totalCount }} 条数据
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="100"
    >
      <div class="receive-item flex" v-for="(item,index) in orderList" :key="index">
        <div class="item-content">
          <section>撤单编号 : {{ item.sn }}</section>
          <section>原始订单号 : {{ item.originalOrderNo }}</section>
          <section>状态 :&nbsp;
            <span v-for="status in OrderCancelStatus()" :key="item.value">
              <span v-if="status.value === item.status" :style="`color: ${status.color}`">
                {{status.label}}
              </span>
            </span>
          </section>
          <section>创建时间 : {{ item.createDate }}</section>
          <section>备注 : {{ item.memo }}</section>
        </div>
        <div class="item-icon" @click="goOrderDetail(item.id,item.sn)">
          <i class="iconfont xiangyou"></i>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import {OrderCancelStatus} from "../common/constant";

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      loading: false,
      finished: true,
      status: 0, // 获取入库单列表状态 请求参数
      orderList: [],
      totalCount: 0,
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
    this.getOrderCancelList ();
  },
  methods: {
    OrderCancelStatus() {
      return OrderCancelStatus
    },
    // 状态切换
    statusChange(value) {
      if (value !== this.status) {
        this.status = value;
        this.currentPage = 1;
        this.orderList = [];
        this.getOrderCancelList();
      }
    },
    // 获取入库单列表
    getOrderCancelList() {
      let param = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        status: this.status
      };
      this.$post(this.URL.findOrderCancelPage, param).then(res => {
        if (res.success) {
          this.totalCount = res.data.totalCount;
          this.orderList = [...this.orderList, ...res.data.records];
          this.finished = res.data.totalPage <= this.currentPage;
        } else {
          this.$toast.fail(res.message);
        }
        this.loading = false;
      });
    },
    // 加载更多
    onLoad() {
      if (!this.finished) {
        this.currentPage++;
        this.getInboundApplyList();
      }
    },
    // 详情
    goOrderDetail(id, sn) {
      this.$router.push({path: "/orderCancelDetail", query: {"orderId": id, "sn":sn}});
    }
  }
};
</script>

<style lang="scss" scoped>
.page-content {
  height: 100vh;
  align-content: flex-start;
}

.nav-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  background-color: #dc6350;
  padding: 0 3rem;
  align-items: center;

  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }

  .activity {
    background-color: white;
    color: #dc6350;
  }

  section:nth-child(2) {
    border-left: none;
    border-right: none;
  }

  section:first-child {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
  }

  section:last-child {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }
}

.order-total {
  display: flex;
  width: 100%;
  height: 2.2rem;
  border-bottom: 1px solid #eee;
  align-items: center;
  padding-left: 0.5rem;
  font-size: 0.9rem;
}

.van-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem 0.8rem;
  color: #444;

  .receive-item {
    padding: 0.5rem 0;
    border-bottom: 1px dashed #eee;

    .item-content {
      display: inline-flex;
      width: 90%;
      flex-wrap: wrap;

      section {
        display: flex;
        width: 100%;
        line-height: 1.2rem;
      }
    }

    .item-icon {
      display: inline-flex;
      width: 10%;
      align-items: center;
      justify-content: flex-end;

      i {
        font-size: 1.5rem;
        color: #dc6350;
      }
    }
  }

  >>> .van-list__loading {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  >>> .van-list__finished-text {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/OrderCancel.vue